module.exports = __webpack_public_path__ + "7637a7caafe0ed4a4f4bdfaa22c947e9.png";